import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEyedropper2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEyedropper2"><Path d="M17 3L3.5 16.5V20.5H7.5L21 7L17 3Z" stroke="currentColor" strokeLinecap="square"/><Path d="M10 7L17 14" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconEyedropper2;
